import { render, staticRenderFns } from "./AssignOfferPopup.vue?vue&type=template&id=2a5a850b&scoped=true&"
import script from "./AssignOfferPopup.vue?vue&type=script&lang=ts&"
export * from "./AssignOfferPopup.vue?vue&type=script&lang=ts&"
import style0 from "./AssignOfferPopup.vue?vue&type=style&index=0&id=2a5a850b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5a850b",
  null
  
)

export default component.exports